import React, { PureComponent } from 'react';
import { Menu, MenuItem } from 'types/IPage';
import styled from 'styled-components';

type Props = {
  menu: Menu[];
}

const SustainableLogoLink = styled.a`
  display: block;
  width: 86px;
  height: 31px;
  margin-left: 8px;
`;

const SustainableLogo = styled.span`
  display: block;
  width: inherit;
  height: inherit;
  background-image: url(${props => props.theme.isRetina ? '/assets/images/sustainablemeal@2x.png' : '/assets/images/sustainablemeal.png'});
  background-size: contain;
  margin-top: -10px;
`;


class FoodMenu extends PureComponent<Props> {
  render() {
    const {
      menu
    } = this.props;

    return (
      <div>
        {Boolean(menu) &&
          <div>
            <hr/>
            <p style={{paddingTop: 20}}><strong>MENU</strong></p>

            {menu.map((item: Menu, index: number) =>
              <div key={`menu-${index}`}>
                {Boolean(item.list_title) &&
                <p style={{marginTop: 30, textTransform: 'uppercase'}}>{item.list_title}</p>
                }
                {item.list_items && item.list_items.map((menuItem: MenuItem, menuItemIndex: number) =>
                  <div key={`menu-${index}-item-${menuItemIndex}`}>
                    <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                      <p style={{marginBottom: 6}}><strong>{menuItem.title}</strong></p>
                      {Boolean(menuItem.sustainable_meal) &&
                      <SustainableLogoLink href={'http://www.sustainablemeal.fi/'} target={'_blank'}>
                          <SustainableLogo />
                      </SustainableLogoLink>
                      }
                    </div>
                    {Boolean(menuItem.description) &&
                    <p>{menuItem.description}</p>
                    }
                  </div>
                )}
              </div>
            )}
          </div>
        }
      </div>
    )
  }
}

export default FoodMenu;


// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/scenes/foods/FoodMenu.tsx